export default __webpack_public_path__ + "static/media/007-mark.919566ef.svg";